import { useTheme, useMediaQuery } from '@mui/material';
import DocumentoUploadPageDesktop from './DocumentoUploadPageDesktop';
import DocumentoUploadPageMobile from './DocumentoUploadPageMobile';

export default function DocumentoDetailPage() {
  const theme = useTheme();
  const isMobile =useMediaQuery(theme.breakpoints.down('md'));
  return isMobile
    ? <DocumentoUploadPageMobile />
    : <DocumentoUploadPageDesktop />;
}